import type { LinkData } from '@eliadmin/core/src/utils/svetech/text';

import { ButtonLink } from '@eliadmin/core/src/components/svetech/ui/button';
import { Icon } from '@eliadmin/core/src/components/svetech/ui/icon';

/**
 * Right side of the header bar, shared by the page header and the open mobile menu so both bars
 * match. Desktop (Figma „Header“ 4468:1078): phone icon + number, then the quote button. Below `lg`
 * (Figma „Header — mobil“ 4710:4062): the quote button with the short label (12/16 on phones)
 * first, 8 px apart from the 40 px phone tile (#f2f3ef, 20 px icon).
 */
export function HeaderActions({
  phone,
  quote,
  quoteShortLabel,
}: {
  phone: LinkData | null;
  quote: LinkData | null;
  /** Short quote label of the mobile bar (universal text „Cenová ponuka“). */
  quoteShortLabel: string;
}) {
  return (
    <div className="flex items-center justify-end gap-2 lg:gap-8">
      {phone ? (
        <a
          href={phone.href}
          aria-label={phone.label}
          className="svt-button flex size-10 items-center justify-center gap-2 rounded-xl rounded-tr-none bg-[#f2f3ef] font-bold text-[#14171a] transition-colors hover:text-[#2c7a25] lg:size-auto lg:rounded-none lg:bg-transparent"
        >
          <Icon name="phone" className="size-5 lg:size-6" />
          <span className="hidden lg:inline">{phone.label}</span>
        </a>
      ) : null}
      {quote ? (
        <ButtonLink
          href={quote.href}
          className="max-lg:order-first max-md:text-xs max-md:leading-4"
        >
          <span className="lg:hidden">{quoteShortLabel}</span>
          <span className="hidden lg:inline">{quote.label}</span>
        </ButtonLink>
      ) : null}
    </div>
  );
}
